import {useState } from 'react';
import { Empty, Radio } from "antd";
import InsureRecordList from './insureRecordList';
import PayList from './payList';
export default function (props) {
    const [valueRadio, setValueRadio] = useState('1');
    const tabList = [
        {
            key: '1',
            label: '投保记录',
            // auth: 'insureManagementRecords',
        },
        {
            key: '2',
            label: '账户流水',
            // auth: 'insureManagementPaymentRecords',
        }
    ];;
    const onChange = (e) => {
        setValueRadio(e?.target?.value);
    }
    return (
        <>
            <div style={{ background: '#fff', padding: 10 }}>
                {
                    tabList.length === 0 ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> : <>
                        <Radio.Group style={{ marginLeft: 15 }} value={valueRadio} onChange={onChange}
                            buttonStyle="solid">
                            {
                                tabList.map((item: any) => {
                                    return <Radio.Button value={item.key}>{item.label}</Radio.Button>
                                })
                            }
                        </Radio.Group>
                        {valueRadio === '1' ? <InsureRecordList /> : <PayList />}
                    </>
                }
            </div>
        </>
    );
}
